import React from "react";

const IPlus = ({ color = "#fff", width = "14", height = "14", ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 14 14"
      fill="none"
      {...props}
    >
      <path
        d="M6.41667 12.1042V1.89583C6.41667 1.57367 6.67783 1.3125 7 1.3125C7.32217 1.3125 7.58333 1.57367 7.58333 1.89583V12.1042C7.58333 12.4263 7.32217 12.6875 7 12.6875C6.67783 12.6875 6.41667 12.4263 6.41667 12.1042Z"
        fill={color}
      />
      <path
        d="M12.1042 6.41667C12.4263 6.41667 12.6875 6.67783 12.6875 7C12.6875 7.32217 12.4263 7.58333 12.1042 7.58333H1.89583C1.57367 7.58333 1.3125 7.32217 1.3125 7C1.3125 6.67783 1.57367 6.41667 1.89583 6.41667H12.1042Z"
        fill={color}
      />
    </svg>
  );
};

export default IPlus;
